import { useState } from "react";

export const LoaderState = () => {
    const [isShow, setIsShow] = useState(false);

    return {
        isShow: {data: isShow, set: setIsShow},
    }
}